<template>
    <div class="firm-type text-nowrap font-weight-bolder py-25 px-50 rounded text-center" :class="row.IsParentFirm ? 'bg-light-success text-success':'bg-light-secondary test-secondary'">
        {{ row.IsParentFirm ? 'ANA FİRMA' : 'FİRMA' }}
    </div>
</template>

<script>
export default {
    props:{
        row:Object,
    },
}
</script>

<style>
.firm-type{
    font-size: 0.85rem;
}
</style>